var Validator = require("./vendors/js-form-validator.min");

window.addEventListener("DOMContentLoaded", function() {
  // page loader
  let pageLoader = document.getElementById("page-loader");
  setTimeout(() => {
    pageLoader.classList.toggle("d-flex");
    pageLoader.classList.toggle("d-none");
  }, 3200);

  // sticky header
  function stickyHeader() {
    let headerElement = document.getElementById("header");
    let scrollCondition = window.scrollY >= headerElement.clientHeight;
    // add fixed classe if the condition is true
    headerElement.classList.toggle("fixed", scrollCondition);
  }
  stickyHeader();
  window.addEventListener("scroll", stickyHeader);

  // toggle header nav
  let toggleNavIcon = document.getElementById("toggle-nav-icon");
  toggleNavIcon.addEventListener("click", function() {
    document.getElementById("header-nav").classList.toggle("show");
    this.classList.toggle("open");
  });

  // header smooth scroll and add class active onscroll
  let HeaderNav = document.getElementById("header-nav");

  function removeHeaderActiveClass() {
    HeaderNav.querySelectorAll(".nav-item").forEach((link) =>
      link.classList.remove("active")
    );
  }

  HeaderNav.addEventListener("click", (e) => {
    e.preventDefault();
    let targetLink = e.target.closest(".nav-link");
    if (targetLink) {
      removeHeaderActiveClass();
      // close header nav
      toggleNavIcon.click();
      // scroll into target section
      document.documentElement.scrollTo({
        top: document.getElementById(targetLink.dataset.nav).offsetTop - 70,
        behavior: "smooth",
      });
    }
  });

  var pageSections = document.querySelectorAll(".page-section");
  window.addEventListener("scroll", function() {
    pageSections.forEach((section) => {
      if (section.offsetTop - 100 <= this.scrollY) {
        removeHeaderActiveClass();
        document
          .querySelector(`[data-nav=${section.id}]`)
          .parentElement.classList.add("active");
      }
    });
  });

  // custom modal
  function hideModal() {
    this.classList.toggle("d-none");
    document.body.classList.toggle("overflow-hidden");
  }

  function handelModalContentClick(e) {
    e.stopPropagation();
  }

  function handelModalcloseIcon(e) {
    e.preventDefault();
    this.closest(".custom-modal").classList.toggle("d-none");
    document.body.classList.toggle("overflow-hidden");
  }
  document.addEventListener("click", (e) => {
    let targetElement = e.target.closest("[data-modal]");
    if (targetElement) {
      let targetModal = document.getElementById(targetElement.dataset.target);
      targetModal.classList.toggle("d-none");
      document.body.classList.toggle("overflow-hidden");
      targetModal.scrollTo(0, 0);
      targetModal.addEventListener("click", hideModal);
      targetModal
        .querySelector(".modal-container")
        .addEventListener("click", handelModalContentClick);
      targetModal
        .querySelector(".close-icon")
        .addEventListener("click", handelModalcloseIcon);
    }
  });

  // file upload
  function previewFile() {
    let file = this.files[0];
    let reader = new FileReader();
    let previewFileName = document.getElementById("preview-file-name");

    reader.onloadend = function() {
      previewFileName.textContent = "Uploaded File: " + file.name;
    };

    if (file) {
      reader.readAsDataURL(file);
    } else {
      previewFileName.textContent = "";
    }
  }

  document
    .querySelector("input[type=file]")
    .addEventListener("change", previewFile);

  // application form validation
  let applicationForm = document.getElementById("application-form");
  if (applicationForm) {
    let options = {
      errorClassName: "error-feedback",
      locale: "en",
      messages: {
        en: {
          required: {
            empty: "This Field Is Required",
          },
          email: {
            incorrect: "Please Enter a Valid Email Address",
          },
          phone: {
            incorrect: "Please Enter a Valid Phone Number",
          },
        },
      },
    };

    // Got to validation
    new Validator(
      applicationForm,
      function(err, res) {
        return res;
      },
      options
    );
  }
});
